"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _require = require('./locale-formal-name-mapping'),
  getLocalesForL10nLocaleISOFolderName = _require.getLocalesForL10nLocaleISOFolderName;
var _require2 = require('./locale-mapping'),
  siteLocaleToL10nLocale = _require2.siteLocaleToL10nLocale;

/**
 * For public consumption we add 'en-US' to the mapping. It's not in the mapping because we don't
 * localize into 'en-US', but for backward compatibility reasons we'll still support it explicitly
 * in apps that consume this package.
 */
var mappingWithEnUs = _objectSpread(_objectSpread({}, siteLocaleToL10nLocale), {}, {
  'en-US': 'en-US'
});

/**
 * All supported site locales in BCP 47 format, including 'en-US'
 * @type {String[]}
 */
var supportedLocales = Object.keys(mappingWithEnUs);

/**
 * All supported l10n locales in BCP 47 format, including 'en-US', mapped to the value true. It's
 * only used internally (not exported).
 * @type {Object}
 */
var l10nLocales = supportedLocales.reduce(function (result, supportedLocale) {
  var l10nLocale = mappingWithEnUs[supportedLocale];
  result[l10nLocale] = true;
  return result;
}, {});

/**
 * @param {String} locale
 *     BCP 47 locale string with language code (required) and optionally a region code.
 *     Examples: 'fr-LU', 'fr-CA', 'de', 'en-US'
 * @returns {Boolean}
 *     True iff we localize specifically for the given locale, or if it's 'en-US'
 */
function isL10nLocale(locale) {
  return l10nLocales[locale] === true;
}

/**
 * Return the l10n locale that should be applied for a given site locale, or null if we do not
 *
 * @param {String} siteLocale
 *     BCP 47 locale string with language code (required) and optionally a region code.
 *     Examples: 'fr-LU', 'fr-CA', 'de', 'en-US'
 * @returns {String}
 *     The l10n locale for the given site locale (or undefined if it's not supported)
 */
function getL10nLocaleForSiteLocale(siteLocale) {
  return mappingWithEnUs[siteLocale];
}
module.exports = {
  supportedLocales: supportedLocales,
  isL10nLocale: isL10nLocale,
  getL10nLocaleForSiteLocale: getL10nLocaleForSiteLocale,
  localeHelper: {
    siteLocaleToL10nLocale: siteLocaleToL10nLocale,
    getLocalesForL10nLocaleISOFolderName: getLocalesForL10nLocaleISOFolderName
  }
};